import { render, staticRenderFns } from "./langWidget.vue?vue&type=template&id=0b78495e&scoped=true"
import script from "./langWidget.ts?vue&type=script&lang=ts&external"
export * from "./langWidget.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78495e",
  null
  
)

export default component.exports